module.exports = __webpack_public_path__ + "static/img/alimentacion.9762087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/categories/alimentacion.png
// module id = /6EL
// module chunks = 1